import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBookmark16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconBookmark16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m8 10.25.6.45L13 14V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v11l4.4-3.3zm0 1.25 4.4 3.3A1 1 0 0 0 14 14V3a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1.6.8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBookmark16);
